import React, { useCallback, useMemo } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { FalsyText } from '@ui-kitten/components/devsupport';
import styled from "../../../theming/util/styled";
import { DNAIcon, Iffy, util } from "../../../index";
import { parseComponentStyle } from './util';
const modifiers = StyleSheet.create({
    alignY: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    roundedNone: {
        borderRadius: 0,
    },
});
const DNAChip = (props) => {
    const { eva, style = {}, rounded, children, onPress, testID, iconLeft } = props;
    const { container, hoverContainer, activeContainer, textStyle, iconStyle, iconName, } = parseComponentStyle(eva.style);
    const childrenText = children?.toString().toUpperCase() === 'MP4' ? 'VIDEO' : children;
    const { color, ...rest } = style;
    const roundedStyle = rounded === false ? modifiers.roundedNone : null;
    const pressableStyle = useCallback(({ pressed, hovered }) => {
        return [
            container,
            roundedStyle,
            modifiers.alignY,
            hovered && hoverContainer,
            pressed && activeContainer,
            rest ? { ...rest } : {},
        ];
    }, [style]);
    const finalIconStyle = useMemo(() => util.mergeStyles(undefined, iconStyle, color ? { color } : {}), [iconStyle, color]);
    const finalTextStyle = useMemo(() => [textStyle, color ? { color } : {}], [textStyle, color]);
    return (<Pressable testID={testID} onPress={onPress} disabled={!onPress} 
    // @ts-ignore: hovered does not exist in PressableStateCallbackType but works
    style={pressableStyle}>
      <Iffy is={iconLeft || onPress}>
        <DNAIcon.Styled name={iconLeft ?? iconName} style={finalIconStyle}/>
      </Iffy>
      <FalsyText testID="chip-text" style={finalTextStyle} component={childrenText}/>
    </Pressable>);
};
export default styled('DNAChip')(DNAChip);
//# sourceMappingURL=DNAChip.js.map